
import { StoreTypes } from "@/assets/js/Types";
import Vue from "vue";
import menuItem from "../MenuItemCom.vue";
import { MenuDetail } from "@/assets/js/Model/ResponseModel";
export default Vue.extend({
  props: ["path"],
  data() {
    return {
      menus: [] as any[],
      currentSid: null as any,
    };
  },
  components: { menuItem },
  watch: {
    path() {
      this.getMenu();
    },
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    menuClick(menu: MenuDetail) {
      if (menu.path.indexOf("http") != -1) {
        window.open(menu.path);
      } else if (this.$route.path.toLowerCase() != menu.path.toLowerCase()) {
        this.$router.push(menu.path);
      }
    },
    getMenu() {
      const project = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      if (project && project.menu) {
        if (project.menu.childrens && project.menu.childrens.length != 0) {
          const m: any = project.menu.childrens.find(
            (x: any) => x.path.toLowerCase() == this.path.toLowerCase()
          );
          if (m) {
            this.menus = m.childrens;
          }
        }
      }
    },
  },
});
